import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import { ResultsScreen } from '../components/ResultsScreen';

export const TestResultsPage = () => {
  const { testId } = useParams();
  const navigate = useNavigate();
  const { user, currentTest, testResults } = useApp();

  const handleBack = () => {
    navigate('/dashboard');
  };

  const handleViewDetails = () => {
    navigate(`/test/${testId}/detailed-results`);
  };

  if (!user) {
    navigate('/signin');
    return null;
  }

  if (!testResults || !currentTest) {
    navigate('/dashboard');
    return null;
  }

  return (
    <div className="bg-white text-black dark:bg-gray-800 dark:text-white">
      <ResultsScreen 
        results={testResults} 
        test={currentTest} 
        user={user}
        onBack={handleBack} 
        onViewDetails={handleViewDetails} 
      />
    </div>
  );
};